import BScroll from "@better-scroll/core";
import MouseWheel from "@better-scroll/mouse-wheel";
import ObserveDOM from "@better-scroll/observe-dom";
import ScrollBar from "@better-scroll/scroll-bar";
import Slide from "@better-scroll/slide";
import PullUp from "@better-scroll/pull-up";

BScroll.use(MouseWheel);
BScroll.use(ObserveDOM);
BScroll.use(ScrollBar);
BScroll.use(Slide);
BScroll.use(PullUp);

export default function initBScroll(el, opts) {
  // console.log(el);
  // console.log(opts);
  const defaultOpts = {
    scrollX: false,
    scrollY: true,
    click: true,

    tap: "tap",
    freeScroll: false,
    observeDOM: true,
    mouseWheel: {
      speed: 20,
      invert: false,
      easeTime: 300,
    },
    scrollbar: {
      fade: false,
      interactive: false,
    },
    disableMouse: false,
    startY: 0,
    bounce: false,
  };
  const options = Object.assign({}, defaultOpts, opts);
  return new BScroll(el, options);
}
